import { useMemo } from 'react';
import AccountViews from '../constants/AccountViews';
import GetCare from '../components/GetCare';
import Insurance from '../components/Insurance';
import Profile from '../components/Profile';
import Manage from '../components/Manage';
import Settings from '../../../routes/account/settings';

export default (viewName: any) =>
  useMemo(() => {
    switch (viewName) {
      default:
      case AccountViews.GetCare:
        return GetCare;
      case AccountViews.Insurance:
        return Insurance;
      case AccountViews.Profile:
        return Profile;
      case AccountViews.Manage:
        return Manage;
      case 'settings':
        return Settings;
    }
  }, [viewName]);
